import React, { useReducer, useEffect, useRef } from 'react';
import './App.css';
import Orb from './component/orb';
import SettingsMenu from './component/SettingsMenu';
import { speechToText } from './speechToText';
import {
    reducer,
    initialState,
    actionTypes,
    userResponses,
    stateNames,
    modes,
} from './statemachine';
// import useLongPress from './useLongPress';
import AudioRecorder from './AudioRecorder';
import IntroCarousel from './IntroCarousel';
import YesNoButtons from './component/YesNoButtons';
import HomeScreenIcons from './component/HomeScreenIcons';
import useAudioPlayer from './modules/useAudioPlayer';
import useAudioContext from './modules/useAudioContext';
import useBufferPlayer from './modules/useBufferPlayer';
import Button from './component/Button';
import PauseScreen from './component/PauseScreen';
import { rgba } from 'style-value-types';

// HELLLO
// Import state machine and pass it into reducer

function App() {
    const { stream, audioContext } = useAudioContext();

    const [state, dispatch] = useReducer(reducer, initialState);

    const audioRef = useRef();

    const playbackEnded = React.useCallback(() => {
        dispatch({
            type: actionTypes.nextPage,
        });
    }, []);

    useAudioPlayer(
        audioContext,
        state &&
            state.mode === modes.active &&
            `audio/${state.session}-${state.stateName}/${state.randomTrackNumber}.mp3`,
        playbackEnded,
        state.paused
    );

    useBufferPlayer(
        audioContext,
        state &&
            state.mode === modes.userAudioPlayback &&
            state.userRecordedIntBuffer,
        playbackEnded,
        state.paused
    );

    const [audioRecorder, setAudioRecorder] = React.useState(null);

    React.useEffect(() => {
        if (!stream || !audioContext) return;

        (async () => {
            console.info('MAKING NEW AUDIO RECORDER');
            const ar = new AudioRecorder(stream, audioContext);
            await ar.initAudio().then(() => setAudioRecorder(ar));
        })();
    }, [stream, audioContext]);

    React.useEffect(() => {
        if (!audioRecorder) return;
        const handleSilence = (recordedAudioBuffer, intbuffer) => {
            // We dont care about silence if the user isnt speaking.
            if (state && state.mode !== modes.userSpeaking) return;

            audioRecorder.setRecording(false);

            console.log('SILENCE CALLBACK RUNNING');

            if (recordedAudioBuffer) {
                // Only Google analyse the yes/no response
                if (
                    state.stateName === stateNames.userYesNo ||
                    state.stateName === stateNames.userYesNo2 ||
                    state.stateName === stateNames.userYesNo3
                ) {
                    console.log('-----calling speech to text-------');
                    dispatch({
                        type: actionTypes.setTranscribingAudio,
                        payload: true,
                    });
                    const speechToTextPromise = speechToText(
                        recordedAudioBuffer,
                        audioRecorder.context.sampleRate
                    );
                    // Response is of type userResponses.yes, userResponses.no etc.
                    speechToTextPromise.then(response => {
                        console.log('-----speech to text returned-------');
                        console.log('response:' + response);
                        // Go to next page based on response
                        if (!state.ignoreSpeechToText) {
                            dispatch({
                                type: actionTypes.nextPage,
                                payload: {
                                    response: response,
                                    currentState: state.stateName,
                                },
                            });
                            dispatch({
                                type: actionTypes.setTranscribingAudio,
                                payload: false,
                            });
                        }
                    });
                }
                // Only save regular responses to audio buffer in, not yes/no
                else {
                    dispatch({
                        type: actionTypes.addIntBuffer,
                        payload: intbuffer,
                    });
                    dispatch({
                        type: actionTypes.nextPage,
                    });
                }
            }
            audioRecorder.reset();
        };
        audioRecorder.onSilence(handleSilence);
        console.log('state.ignoreSpeechToText', state.ignoreSpeechToText);

        if (state.ignoreSpeechToText) {
            console.log('in here!!!!!!!!!!!!!!!!!!!!!');
            audioRecorder.setRecording(false);
        }
    }, [audioRecorder, state]);

    // React.useEffect(()=>{

    // }[state.ignoreSpeechToText])

    React.useEffect(() => {
        if (!audioRecorder) return;
        audioRecorder.setSilenceSeconds(state.silenceSeconds);
    }, [audioRecorder, state.silenceSeconds]);

    // console.log(state);

    // PAUSE RECORDING (i.e. stop recording and save results to buffer)
    useEffect(() => {
        if (state.mode === modes.userSpeaking) {
            state.paused
                ? audioRecorder.setRecording(false)
                : audioRecorder.setRecording(true);
        }
    }, [state.paused, state.mode, audioRecorder]);

    // Long press takes you back to the home screen.
    // const orbLongPress = useLongPress(function() {
    //     dispatch({
    //         type: actionTypes.setPause,
    //         payload: true,
    //     });
    //     dispatch({ type: actionTypes.stop });
    // }, 1000);

    // console.log('Paused: ', state.paused);

    return (
        <div style={{ 
        height: '100vh', 
        width: '100vw', 
        backgroundColor: 'black' }}>
            {state.stateName === stateNames.tutorial ? (
                <IntroCarousel
                    endTutorial={() =>
                        dispatch({
                            type: actionTypes.nextPage,
                        })
                    }
                />
            ) : (
                <div>
                    {state.paused && !(state.stateName === stateNames.home) && (
                        <PauseScreen
                            unPause={() => {
                                dispatch({
                                    type: actionTypes.setPause,
                                    payload: false,
                                });
                            }}
                            endSession={() => {
                                dispatch({
                                    type: actionTypes.stop,
                                });
                            }}
                        />
                    )}

                    <div
                        style={{
                            backgroundColor: 'black',
                            height: '100vh',
                            width: '100vw',
                            color: 'white',
                            display: 'grid',
                            gridTemplateRows: '22% 50% 22% 6%',
                        }}
                        className={
                            state.paused && state.stateName !== stateNames.home
                                ? 'blurry main-screen'
                                : 'main-screen'
                        }
                    >
                        {false && state.mode === modes.active && (
                            <audio
                                preload="auto"
                                ref={audioRef}
                                style={{ display: 'none' }}
                                src={`audio/${state.session}-${state.stateName}/${state.randomTrackNumber}.mp3`}
                            >
                                Your browser does not support the
                                <code>audio</code> element.
                            </audio>
                        )}
                        <div
                            className="app-header"
                            style={{
                                textAlign: 'center',
                                display: 'grid',
                                gridTemplateRows: '16fr 3fr 1fr',
                                opacity: '0.9',
                                backgroundColor: 'black',
                                alignContent: 'center',
                            }}
                        >
                            <div />
                            <h1
                                style={{
                                    fontWeight: 'normal',
                                    fontSize: '1.2em',
                                }}
                            >
                                {state.stateName === stateNames.home
                                    ? 'Tap to begin' 
                                    : ''}
                            </h1>
                            <div/>
                        </div>
                        <div
                            className="orb-area"
                            style={{
                                width: '100%',
                                height: '100%',
                                display: 'grid',
                                justifyContent: 'center',
                                backgroundColor: 'black',
                            }}
                            onClick={() => {
                                if (state.stateName === stateNames.home) {
                                    dispatch({ type: actionTypes.nextPage });
                                } else {
                                    dispatch({
                                        type: actionTypes.setPause,
                                        // payload: true,
                                    });
                                }
                            }}
                        >
                            <Orb
                                orbstate={state.mode}
                                audioRecorder={audioRecorder}
                            />
                        </div>
                        <div
                            className="footer-area"
                            style={{
                                textAlign: 'center',
                                backgroundColor: 'transparent',
                                paddingTop: '12%',
                                zIndex: '10',
                            }}
                        >
                            {state.mode === modes.userSpeaking &&
                                state.manualContinueButton &&
                                !state.temporarilyHideContinueButton &&
                                !state.transcribingAudio && (
                                    <Button
                                        label="Continue"
                                        onClick={() => {
                                            audioRecorder.continue();
                                        }}
                                    />
                                )}
                            {state.displayYesNoButtons && (
                                <YesNoButtons
                                    noDispatch={() =>
                                        dispatch({
                                            type: actionTypes.nextPage,
                                            payload: {
                                                response: userResponses.no,
                                                currentState: state.stateName,
                                                ignoreSpeechToText: true,
                                            },
                                        })
                                    }
                                    yesDispatch={() =>
                                        dispatch({
                                            type: actionTypes.nextPage,
                                            payload: {
                                                response: userResponses.yes,
                                                currentState: state.stateName,
                                                ignoreSpeechToText: true,
                                            },
                                        })
                                    }
                                />
                            )}
                            <div
                                style={{
                                    display: 'grid',
                                    justifyItems: 'center',
                                }}
                            />
                        </div>
                        {state.stateName === stateNames.home &&
                        !state.showingMenu ? (
                            <HomeScreenIcons
                                toggleMenuDispatch={() =>
                                    dispatch({
                                        type: actionTypes.toggleMenu,
                                    })
                                }
                                openTutorialDispatch={() =>
                                    dispatch({
                                        type: actionTypes.openTutorial,
                                    })
                                }
                            />
                        ) : (
                            <div />
                        )}
                    </div>
                </div>
            )}

            {state.showingMenu && (
                <SettingsMenu
                    toggleMenu={() =>
                        dispatch({
                            type: actionTypes.toggleMenu,
                        })
                    }
                    setSilenceSeconds={newSilenceSeconds =>
                        dispatch({
                            type: actionTypes.setSilenceSeconds,
                            payload: newSilenceSeconds,
                        })
                    }
                    silenceSeconds={state.silenceSeconds}
                    manualContinueButton={state.manualContinueButton}
                    setOffManualContinueButton={() => {
                        dispatch({
                            type: actionTypes.setManualContinueButton,
                            payload: false,
                        });
                    }}
                    setOnManualContinueButton={() => {
                        dispatch({
                            type: actionTypes.setManualContinueButton,
                            payload: true,
                        });
                    }}
                />
            )}
        </div>
    );
}

export default App;
